var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"currentColor","strokeWidth":"1","fill":"none","fillRule":"evenodd","strokeLinecap":"round"},React.createElement("path",{"d":"M1.343 1.343l11.314 11.314M12.657 1.343L1.343 12.657"})));
}

Close.defaultProps = {"viewBox":"0 0 14 14"};

module.exports = Close;

Close.default = Close;
